import { defineMessages } from 'react-intl';

const prefix = 'front_photographer';

export const FrontPhotographerMessages = defineMessages({
  pageTitle: {
    id: `${prefix}_pageTitle`,
    defaultMessage: 'Vous êtes photographe ?',
  },
  introTitle: {
    id: `${prefix}_introTitle`,
    defaultMessage: 'Shoootin recrute des experts',
  },
  introp1: {
    id: `${prefix}_introp1`,
    defaultMessage:
      'Shoootin travaille uniquement avec des photographes professionnels expérimentés. Nous vous assurons des missions régulières, quand vous êtes disponibles pour travailler avec nous.',
  },
  introp2: {
    id: `${prefix}_introp2`,
    defaultMessage:
      'Rien n’est laissé au hasard, nous investissons beaucoup sur notre relation avec les photographes et nous faisons au mieux pour les satisfaire.',
  },
  introJoinUs: {
    id: `${prefix}_introJoinUs`,
    defaultMessage: 'Rejoignez-nous',
  },

  // begin highlights
  highlightsPanels_1_title: {
    id: `${prefix}_highlightsPanels_1_title`,
    defaultMessage: 'Où vous voulez',
  },
  highlightsPanels_1_p1: {
    id: `${prefix}_highlightsPanels_1_p1`,
    defaultMessage:
      'Nous vous proposons des missions seulement sur les zones que vous désirez.',
  },
  highlightsPanels_2_title: {
    id: `${prefix}_highlightsPanels_2_title`,
    defaultMessage: 'Quand vous voulez',
  },
  highlightsPanels_2_p1: {
    id: `${prefix}_highlightsPanels_2_p1`,
    defaultMessage:
      'Choisissez vos horaires et travaillez seulement quand ça vous arrange !',
  },

  highlightsPanels_3_title: {
    id: `${prefix}_highlightsPanels_3_title`,
    defaultMessage: 'Complément',
  },
  highlightsPanels_3_p1: {
    id: `${prefix}_highlightsPanels_3_p1`,
    defaultMessage:
      'Utilisez votre temps libre pour gagner un complément de revenu intéressant.',
  },
  // end highlights

  // being timeline
  timelineTitle: {
    id: `${prefix}_timelineTitle`,
    defaultMessage: 'Comment ça marche ?',
  },
  timelineMention1: {
    id: `${prefix}_timelineMention1`,
    defaultMessage: 'Vous avez des questions ? ',
  },
  timelineMention2: {
    id: `${prefix}_timelineMention2`,
    defaultMessage: 'Découvrez notre',
  },

  timeline_1: {
    id: `${prefix}_timeline_1`,
    defaultMessage:
      'Nous avons développé une application mobile pour vous permettre de gérer vos missions depuis votre téléphone.',
  },
  timeline_2: {
    id: `${prefix}_timeline_2`,
    defaultMessage:
      'Pour optimiser votre temps, nous vous proposons plusieurs reportages le même jour.',
  },
  timeline_3: {
    id: `${prefix}_timeline_3`,
    defaultMessage:
      'Il ne vous reste plus qu’à livrer les photos de vos différents shooting le soir même.',
  },
  // end timeline

  //begin testimonials
  testimonialsTitle: {
    id: `${prefix}_testimonialsTitle`,
    defaultMessage: 'Nos photographes prennent la parole',
  },
  testimonialsp1: {
    id: `${prefix}_testimonialsp1`,
    defaultMessage:
      'L’ équipe de photographes Shoootin révèle et met en valeur chaque jour l’atmosphère et la beauté des biens de nos clients. Elle est composée d’une équipe dynamique de professionnels sélectionnés sur le volet.',
  },

  testimonial1Text: {
    id: `${prefix}_testimonial1Text`,
    defaultMessage: 'Testimonial 1 Text',
  },
  testimonial1Name: {
    id: `${prefix}_testimonial1Name`,
    defaultMessage: 'Testimonial 1 Name',
  },
  testimonial1City: {
    id: `${prefix}_testimonial1City`,
    defaultMessage: 'Testimonial 1 City',
  },

  testimonial2Text: {
    id: `${prefix}_testimonial2Text`,
    defaultMessage: 'Testimonial 2 Text',
  },
  testimonial2Name: {
    id: `${prefix}_testimonial2Name`,
    defaultMessage: 'Testimonial 2 Name',
  },
  testimonial2City: {
    id: `${prefix}_testimonial2City`,
    defaultMessage: 'Testimonial 2 City',
  },

  testimonial3Text: {
    id: `${prefix}_testimonial3Text`,
    defaultMessage: 'Testimonial 3 Text',
  },
  testimonial3Name: {
    id: `${prefix}_testimonial3Name`,
    defaultMessage: 'Testimonial 3 Name',
  },
  testimonial3City: {
    id: `${prefix}_testimonial3City`,
    defaultMessage: 'Testimonial 3 City',
  },
  testimonial4Text: {
    id: `${prefix}_testimonial4Text`,
    defaultMessage: 'Testimonial 4 Text',
  },
  testimonial4Name: {
    id: `${prefix}_testimonial4Name`,
    defaultMessage: 'Testimonial 4 Name',
  },
  testimonial4City: {
    id: `${prefix}_testimonial4City`,
    defaultMessage: 'Testimonial 4 City',
  },

  //end testimonials

  //begin banner
  bannerTitle: {
    id: `${prefix}_bannerTitle`,
    defaultMessage: 'Une meilleure collaboration',
  },
  bannerP1: {
    id: `${prefix}_bannerP1`,
    defaultMessage:
      'La notation est très importante chez Shoootin.\n\n\n' +
      'Une bonne note augmente le volume de reportages de 20% environ.\n\n\n',
  },

  //end banner

  //begin app
  appTitle: {
    id: `${prefix}_appTitle`,
    defaultMessage: 'Une application qui vous est dédiée ',
  },
  appP1: {
    id: `${prefix}_appP1`,
    defaultMessage:
      'Nous sommes là pour vous proposer un complément de revenu quand vous êtes disponible. Il vous suffit simplement de mettre à jour votre planning et la zone géographique où vous voulez travailler sur votre compte photographe.\n\n\n' +
      'Nous avons développé une application mobile pour vous permettre de gérer cela facilement.\n\n\n' +
      'Voici les liens pour le téléchargement :',
  },

  //end app

  //begin join
  joinTitle: {
    id: `${prefix}_joinTitle`,
    defaultMessage: 'Rejoignez-nous !',
  },
  joinP1: {
    id: `${prefix}_joinP1`,
    defaultMessage:
      'Nous avons besoin de connaître certaines informations afin de pouvoir commencer à travailler avec vous. En cas de préselection un entretien sur Skype sera organisé.',
  },
  joinLink: {
    id: `${prefix}_joinLink`,
    defaultMessage: 'Déposez votre candidature',
  },

  //end join
});
